import DS3_FormHelpers from "./FormHelpers";
import DS3_EmailVerification from "./EmailVerification";
import DS3_PhoneVerification from "./PhoneVerification";
import DS3_Multistep from "./Multistep";
import DS3_Events from "./Events";
import DS3_DispatchEvents from "./DispatchEvents";
import DS3_SendToTray from "./SendToTray";

var DS3 = new Object();

DS3.version = "1.0.3";
DS3.count = 1; // for testing

DS3.$el = null;
DS3.formEl = null;
DS3.formId = null;

DS3.formSettings = function ($el) {
  let env = $el.attr("data-env");
  DS3.portalId = env === "staging" ? "50989089" : "23623022";
  DS3.formId = $el[0].hasAttribute("data-form-id")
    ? $el.attr("data-form-id")
    : env === "staging"
      ? "0244e176-c810-4aa8-b2be-be2de129fde6"
      : "7fc07ca5-c38c-4538-a6a2-3d0485cae4fc";

  if ($el[0].hasAttribute("data-form-id")) {
    if (helpers.shouldDebug("ds3"))
      console.log(`[DS3] Custom Form: ${DS3.formId}`);
  }
};

DS3.ready = function ($el) {
  if (helpers.shouldDebug("ds3")) console.log("[DS3] ready", this.count++);
  this.$el = $el;

  if (helpers.shouldDebug("ds3")) console.log("[DS3] init", $el);

  this.formSettings($el);

  this.initForm($el);

  sessionStorage.setItem("demoFormListenerIsActive", 1); // Prevents ThryvQualified listener events from being sent

  DS3_Events.listen($el);
};
DS3.initForm = function () {
  hbspt.forms.create({
    region: "na1",
    portalId: this.portalId,
    formId: this.formId,
    cssClass:
      "hubspot-demo-scheduler-lead-info-form hs-form-w-consent-checkbox",
    submitButtonClass:
      "btn btn-orange uppercase semibold hspacing1 submit-btn wide-btn mt-2",
    target: "#lead-info-form-" + this.formId,
    onFormReady: this.onFormReady,
    onFormSubmitted: this.onFormSubmitted,
  });

  if (helpers.shouldDebug("ds3")) {
    console.log(`[DS3] HS Portal ID: ${this.portalId}`);
    console.log(`[DS3] HS Form ID: ${this.formId}`);
  }

  const $video = $(".preview-button");
  $("#pausePreview").on("click", function (e) {
    $video.each(function () {
      this.pause();
    });
  });
  $(document).on("click", function (e) {
    // If the click is NOT on the video or button
    if (!$(e.target).closest(".preview-button, #pausePreview").length) {
      $video.each(function () {
        this.play();
      });
    }
  });
  window.enablePlayBtn = function ($el) {
    console.log("enablePlayBtn");
    $el.find(".spinner-wrap").hide();
    $el.find(".custom-play-button-inner").show();
  };
};

DS3.onFormReady = function ($form) {
  var _this = DS3;
  _this.formEl = $form;

  // console.log('DS3.onFormReady', _this.count++);
  if (helpers.shouldDebug("ds3")) console.log("[DS3] onFormReady", $form);

  DS3_FormHelpers.preventFormSubmit($form);
  DS3_FormHelpers.field_email($form);
  DS3_FormHelpers.field_company($form);
  DS3_FormHelpers.field_name($form);
  DS3_FormHelpers.field_industry($form);
  DS3_FormHelpers.field_country($form);
  DS3_FormHelpers.fields_utms($form);
  DS3_FormHelpers.fields_adps($form);
  DS3_FormHelpers.fields_profile($form);
  DS3_FormHelpers.field_salesChannel($form);
  DS3_FormHelpers.field_requestedDemoType($form);
  DS3_FormHelpers.field_zip($form);
  DS3_FormHelpers.setAdditionalRequiredFields($form);
  DS3_FormHelpers.setFieldLabelVisibilty($form);

  DS3_EmailVerification.init($form);
  DS3_PhoneVerification.init($form);
  DS3_Multistep.init($form);
};

DS3.onFormSubmitted = function ($form, data) {
  var _this = DS3;

  DS3_DispatchEvents.onFormSubmitted(_this.formEl, data);

  // console.log('DS3.onFormSubmitted', _this.count++);

  if (helpers.shouldDebug("ds3"))
    console.log("[DS3] onFormSubmitted", $form, data);
  // console.log('DS3.onFormSubmitted data.submissionValues', data.submissionValues);

  helpers.dispatchEvent("ds3_info_submit", data.submissionValues);

  DS3_FormHelpers.setHubspotContactId($form);

  // Change to last step on submit if multistep enabled
  if (_this.$el[0].hasAttribute("data-multistep")) {
    const currStep = parseInt(_this.$el[0].getAttribute("data-step"));
    const nextStep = currStep + 1;

    _this.$el[0].setAttribute("data-step", nextStep);
  }

  // Once the HubSpot form is submitted, send form submission
  // data to Tray. For AU & NZ the routing is handled there.
  // Also we want to keep track of the abandoned demo user data
  // DS3_SendToTray.send(data);
};

window.DS3 = DS3;

// export default DS3;
